import { ValidationErrorType } from './validation-error-type.enum';

export class ValidationError {
  error: string;
  errorType: ValidationErrorType;
  propertyName?: string;
  injectValues?: Record<string, string | number>;

  constructor(
    error = 'backend.validation.invalid_value',
    options?: {
      errorType?: ValidationErrorType;
      propertyName?: string;
      injectValues?: Record<string, string | number>;
    },
  ) {
    this.error = error;
    this.errorType = options?.errorType || ValidationErrorType.global;
    this.propertyName = options?.propertyName;
    this.injectValues = options?.injectValues;
  }
}
